import {
  SelectSessionButton,
} from './KeysAndSigningUI';
import {
  Header,
  ForDevelopment,
} from './MonacottoMiscUI';
import {
  TextLine3,
} from './UtilComponents';
import {
  useGlobalStateSelector,
  words,
  royaltyPercentageDigit,
} from './globalState';
import {
  handleClickGetPermitHistory,
  handleClickGetPermittedHistory,
  handleClickGetPermittedInclusivelyHistory,
  handleClickGetRequestPermissionHistory,
  handleClickGetRequestedPermissionHistory,
  handleClickGetDelegateHistory,
  handleClickGetDelegatedHistory,
  handleClickPermit,
  handleClickRequestPermission,
  handleClickDelegate,
} from './permission';
import {
  keepKeyPairsInMemory,
  handleClickNfc,
  getSecretsFromNativeApp,
  handleClickMpurse,
} from './keysAndSigning';
import {
  handleClickAddressHistory,
} from './monacottoMisc';
import {
  handleClickScanQr,
} from './utils';
import iconMpurse from './mpurse.png';
import iconList from './format_list_bulleted_FILL0_wght400_GRAD0_opsz48.svg';
import iconSign from './history_edu_FILL0_wght400_GRAD0_opsz48.svg';
import iconSearch from './search_FILL0_wght400_GRAD0_opsz48.svg';
import iconCircleLeft from './arrow_circle_left_FILL0_wght400_GRAD0_opsz48.svg';
import iconCircleRight from './arrow_circle_right_FILL0_wght400_GRAD0_opsz48.svg';
import iconHandShake from './handshake_FILL0_wght400_GRAD0_opsz48.svg';

// PERMISSION
function Permission() {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const cookies = useGlobalStateSelector( ({ cookies }) => cookies );
  const setCookie = useGlobalStateSelector( ({ setCookie }) => setCookie );
  let historyItems;
  let historyFunction;
  let arrowRight;
  let arrowLeft;
  let addressPermitToField;

  if (state.getPermissionHistory.action === 'permit') {
    if (state.permitHistory[state.getPermissionHistory.addressMain] !== undefined &&
        state.permitHistory[state.getPermissionHistory.addressMain].permit !== undefined) {
      historyItems = state.permitHistory[state.getPermissionHistory.addressMain].permit.map( record => {
        if (true) {
          return <PermitRecord record={record} />
        }
        else {
          return null;
        }
      });

      historyItems.unshift(<PermitRecordTitle />);
    }
    else {
      historyItems = [<PermitRecordTitle />];
    }

    historyFunction = async (pagingIndex) => {
      const result = await handleClickGetPermitHistory(state, dispatch, cookies, setCookie, pagingIndex);

      if (result?.message === 'nfcRequired') {
        const callback = (keyPairs) => {
          handleClickGetPermitHistory(state, dispatch, cookies, setCookie, pagingIndex, keyPairs);
          keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
        };

        handleClickNfc(state, dispatch, callback);
      }
      else if (result?.message === 'nfcNativeRequired') {
        const { keyPairs } = await getSecretsFromNativeApp({ dispatch, pass: state.config.clientParameters.specialMessage, language: state.language, network: state.networkMona });

        handleClickGetPermitHistory(state, dispatch, cookies, setCookie, pagingIndex, keyPairs);
        keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
      }
      else if (result?.message === 'bcRequired') {
        const callback = (keyPairs) => {
          handleClickGetPermitHistory(state, dispatch, cookies, setCookie, pagingIndex, keyPairs);
          keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
        };

        handleClickScanQr(state, dispatch, callback);
      }
    };
  }
  else if (state.getPermissionHistory.action === 'permitted') {
    if (state.permittedHistory[state.getPermissionHistory.addressMain] !== undefined &&
        state.permittedHistory[state.getPermissionHistory.addressMain].permitted !== undefined) {
      historyItems = state.permittedHistory[state.getPermissionHistory.addressMain].permitted.map( record => {
        if (true) {
          return <PermittedRecord record={record} />
        }
        else {
          return null;
        }
      });

      historyItems.unshift(<PermittedRecordTitle />);
    }
    else {
      historyItems = [<PermittedRecordTitle />];
    }

    historyFunction = async (pagingIndex) => {
      const result = await handleClickGetPermittedHistory(state, dispatch, cookies, setCookie, pagingIndex);

      if (result?.message === 'nfcRequired') {
        const callback = (keyPairs) => {
          handleClickGetPermittedHistory(state, dispatch, cookies, setCookie, pagingIndex, keyPairs);
          keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
        };

        handleClickNfc(state, dispatch, callback);
      }
      else if (result?.message === 'nfcNativeRequired') {
        const { keyPairs } = await getSecretsFromNativeApp({ dispatch, pass: state.config.clientParameters.specialMessage, language: state.language, network: state.networkMona });

        handleClickGetPermittedHistory(state, dispatch, cookies, setCookie, pagingIndex, keyPairs);
        keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
      }
      else if (result?.message === 'bcRequired') {
        const callback = (keyPairs) => {
          handleClickGetPermittedHistory(state, dispatch, cookies, setCookie, pagingIndex, keyPairs);
          keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
        };

        handleClickScanQr(state, dispatch, callback);
      }
    };
  }
  else if (state.getPermissionHistory.action === 'permittedInclusively') {
    if (state.permittedInclusivelyHistory[state.getPermissionHistory.addressMain]?.permitted !== undefined) {
      historyItems = state.permittedInclusivelyHistory[state.getPermissionHistory.addressMain].permitted.map( record => {
        if (true) {
          return <PermittedRecord record={record} />
        }
        else {
          return null;
        }
      });

      historyItems.unshift(<PermittedRecordTitle />);
    }
    else {
      historyItems = [<PermittedRecordTitle />];
    }

    historyFunction = async (pagingIndex) => {
      const result = await handleClickGetPermittedInclusivelyHistory(state, dispatch, cookies, setCookie, pagingIndex);

      if (result?.message === 'nfcRequired') {
        const callback = (keyPairs) => {
          handleClickGetPermittedInclusivelyHistory(state, dispatch, cookies, setCookie, pagingIndex, keyPairs);
          keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
        };

        handleClickNfc(state, dispatch, callback);
      }
      else if (result?.message === 'nfcNativeRequired') {
        const { keyPairs } = await getSecretsFromNativeApp({ dispatch, pass: state.config.clientParameters.specialMessage, language: state.language, network: state.networkMona });

        handleClickGetPermittedInclusivelyHistory(state, dispatch, cookies, setCookie, pagingIndex, keyPairs);
        keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
      }
      else if (result?.message === 'bcRequired') {
        const callback = (keyPairs) => {
          handleClickGetPermittedInclusivelyHistory(state, dispatch, cookies, setCookie, pagingIndex, keyPairs);
          keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
        };

        handleClickScanQr(state, dispatch, callback);
      }
    };
  }
  else if (state.getPermissionHistory.action === 'requestPermission') {
    if (state.requestPermissionHistory[state.getPermissionHistory.addressMain] !== undefined &&
        state.requestPermissionHistory[state.getPermissionHistory.addressMain].requestPermission !== undefined) {
      historyItems = state.requestPermissionHistory[state.getPermissionHistory.addressMain].requestPermission.map( record => {
        if (true) {
          return <RequestPermissionRecord record={record} />
        }
        else {
          return null;
        }
      });

      historyItems.unshift(<RequestPermissionRecordTitle />);
    }
    else {
      historyItems = [<RequestPermissionRecordTitle />];
    }

    historyFunction = async (pagingIndex) => {
      const result = await handleClickGetRequestPermissionHistory(state, dispatch, cookies, setCookie, pagingIndex);

      if (result?.message === 'nfcRequired') {
        const callback = (keyPairs) => {
          handleClickGetRequestPermissionHistory(state, dispatch, cookies, setCookie, pagingIndex, keyPairs);
          keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
        };

        handleClickNfc(state, dispatch, callback);
      }
      else if (result?.message === 'nfcNativeRequired') {
        const { keyPairs } = await getSecretsFromNativeApp({ dispatch, pass: state.config.clientParameters.specialMessage, language: state.language, network: state.networkMona });

        handleClickGetRequestPermissionHistory(state, dispatch, cookies, setCookie, pagingIndex, keyPairs);
        keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
      }
      else if (result?.message === 'bcRequired') {
        const callback = (keyPairs) => {
          handleClickGetRequestPermissionHistory(state, dispatch, cookies, setCookie, pagingIndex, keyPairs);
          keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
        };

        handleClickScanQr(state, dispatch, callback);
      }
    };
  }
  else if (state.getPermissionHistory.action === 'requestedPermission') {
    if (state.requestedPermissionHistory[state.getPermissionHistory.addressMain] !== undefined &&
        state.requestedPermissionHistory[state.getPermissionHistory.addressMain].requestedPermission !== undefined) {
      historyItems = state.requestedPermissionHistory[state.getPermissionHistory.addressMain].requestedPermission.map( record => {
        if (true) {
          return <RequestedPermissionRecord record={record} />
        }
        else {
          return null;
        }
      });

      historyItems.unshift(<RequestedPermissionRecordTitle />);
    }
    else {
      historyItems = [<RequestedPermissionRecordTitle />];
    }

    historyFunction = async (pagingIndex) => {
      const result = await handleClickGetRequestedPermissionHistory(state, dispatch, cookies, setCookie, pagingIndex);

      if (result?.message === 'nfcRequired') {
        const callback = (keyPairs) => {
          handleClickGetRequestedPermissionHistory(state, dispatch, cookies, setCookie, pagingIndex, keyPairs);
          keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
        };

        handleClickNfc(state, dispatch, callback);
      }
      else if (result?.message === 'nfcNativeRequired') {
        const { keyPairs } = await getSecretsFromNativeApp({ dispatch, pass: state.config.clientParameters.specialMessage, language: state.language, network: state.networkMona });

        handleClickGetRequestedPermissionHistory(state, dispatch, cookies, setCookie, pagingIndex, keyPairs);
        keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
      }
      else if (result?.message === 'bcRequired') {
        const callback = (keyPairs) => {
          handleClickGetRequestedPermissionHistory(state, dispatch, cookies, setCookie, pagingIndex, keyPairs);
          keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
        };

        handleClickScanQr(state, dispatch, callback);
      }
    };
  }
  else if (state.getPermissionHistory.action === 'delegate') {
    if (state.delegateHistory[state.getPermissionHistory.addressMain] !== undefined &&
        state.delegateHistory[state.getPermissionHistory.addressMain].delegate !== undefined) {
      historyItems = state.delegateHistory[state.getPermissionHistory.addressMain].delegate.map( record => {
        if (true) {
          return <DelegateRecord record={record} />
        }
        else {
          return null;
        }
      });

      historyItems.unshift(<DelegateRecordTitle />);
    }
    else {
      historyItems = [<DelegateRecordTitle />];
    }

    historyFunction = async (pagingIndex) => {
      const result = await handleClickGetDelegateHistory(state, dispatch, cookies, setCookie, pagingIndex);

      if (result?.message === 'nfcRequired') {
        const callback = (keyPairs) => {
          handleClickGetDelegateHistory(state, dispatch, cookies, setCookie, pagingIndex, keyPairs);
          keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
        };

        handleClickNfc(state, dispatch, callback);
      }
      else if (result?.message === 'nfcNativeRequired') {
        const { keyPairs } = await getSecretsFromNativeApp({ dispatch, pass: state.config.clientParameters.specialMessage, language: state.language, network: state.networkMona });

        handleClickGetDelegateHistory(state, dispatch, cookies, setCookie, pagingIndex, keyPairs);
        keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
      }
      else if (result?.message === 'bcRequired') {
        const callback = (keyPairs) => {
          handleClickGetDelegateHistory(state, dispatch, cookies, setCookie, pagingIndex, keyPairs);
          keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
        };

        handleClickScanQr(state, dispatch, callback);
      }
    };
  }
  else { // delegated
    if (state.delegatedHistory[state.getPermissionHistory.addressMain] !== undefined &&
        state.delegatedHistory[state.getPermissionHistory.addressMain].delegated !== undefined) {
      historyItems = state.delegatedHistory[state.getPermissionHistory.addressMain].delegated.map( record => {
        if (true) {
          return <DelegatedRecord record={record} />
        }
        else {
          return null;
        }
      });

      historyItems.unshift(<DelegatedRecordTitle />);
    }
    else {
      historyItems = [<DelegatedRecordTitle />];
    }

    historyFunction = async (pagingIndex) => {
      const result = await handleClickGetDelegatedHistory(state, dispatch, cookies, setCookie, pagingIndex);

      if (result?.message === 'nfcRequired') {
        const callback = (keyPairs) => {
          handleClickGetDelegatedHistory(state, dispatch, cookies, setCookie, pagingIndex, keyPairs);
          keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
        };

        handleClickNfc(state, dispatch, callback);
      }
      else if (result?.message === 'nfcNativeRequired') {
        const { keyPairs } = await getSecretsFromNativeApp({ dispatch, pass: state.config.clientParameters.specialMessage, language: state.language, network: state.networkMona });

        handleClickGetDelegatedHistory(state, dispatch, cookies, setCookie, pagingIndex, keyPairs);
        keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
      }
      else if (result?.message === 'bcRequired') {
        const callback = (keyPairs) => {
          handleClickGetDelegatedHistory(state, dispatch, cookies, setCookie, pagingIndex, keyPairs);
          keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
        };

        handleClickScanQr(state, dispatch, callback);
      }
    };
  }

  // 矢印

  if ( state.getPermissionHistory.pagingIndex[state.getPermissionHistory.action] >= 1 ) {
    arrowLeft = <div>
      <button className='flexRow justifyContentCenter alignItemsCenter size2x2Large backgroundColorTransparent borderNone cursor borderRadiusCircle riseOut2 '
        onClick={ () => historyFunction(state.getPermissionHistory.pagingIndex[state.getPermissionHistory.action] - 1) }
      >
        <img className='size2x2' src={iconCircleLeft} alt='left' />
      </button>
    </div>
  }
  else {
    arrowLeft = <div>
      <button className='size2x2Large backgroundColorTransparent borderNone' disabled={true} >
        <div className='size2x2' />
      </button>
    </div>
  }

  if ( state.getPermissionHistory.lastEvaluatedKey[state.getPermissionHistory.action][state.getPermissionHistory.pagingIndex[state.getPermissionHistory.action]] !== undefined &&
       state.getPermissionHistory.lastEvaluatedKey[state.getPermissionHistory.action][state.getPermissionHistory.pagingIndex[state.getPermissionHistory.action]] !== null ) {
    arrowRight = <div>
      <button className='flexRow justifyContentCenter alignItemsCenter size2x2Large backgroundColorTransparent borderNone cursor borderRadiusCircle riseOut2 '
        onClick={ () => { historyFunction(state.getPermissionHistory.pagingIndex[state.getPermissionHistory.action] + 1) } }
      >
        <img className='size2x2' src={iconCircleRight} alt='right' />
      </button>
    </div>
  }
  else {
    arrowRight = <div>
      <button className='size2x2Large backgroundColorTransparent borderNone' disabled={true} >
        <div className='size2x2' />
      </button>
    </div>
  }

  // 出品許可先アドレス

  if (state.permit.mode === 'individual') {
    addressPermitToField =
    <div>
      {/* PC */}
      <div className="visibleLargeOrMore">
        <div className='flexRow justifyContentFlexStart alignItemsCenter marginTop1 '>
          <TextLine3 fieldName='addressPermitTo' keys={['permit', 'addressPermitTo']} face={words.addressPermitTo[state.language]} tooltip={true} />
          <SelectSessionButton stateKeysToSetAddress={[['permit', 'addressPermitTo']]} stateKeysToSetUserName={[]} />
          <button className='button1' onClick={ () => handleClickMpurse(state, dispatch, ['permit', 'addressPermitTo']) }>
            <img className='size2x2' src={iconMpurse} alt='mpurse' />
          </button>
          <button className='button1' onClick={ () => handleClickAddressHistory(state, dispatch, cookies, ['permit', 'addressPermitTo']) }>
            <img className='size2x2' src={iconList} alt='list' />
          </button>
        </div>
      </div>
      {/* SP */}
      <div className="visibleMiddleOrLess">
        <div className='flexColumn alignItemsFlexStart marginTopBottom0p5 '>
          <TextLine3 fieldName='addressPermitTo' keys={['permit', 'addressPermitTo']} face={words.addressPermitTo[state.language]} tooltip={true} />
          <div className='flexRow justifyContentFlexStart alignItemsCenter '>
            <SelectSessionButton stateKeysToSetAddress={[['permit', 'addressPermitTo']]} stateKeysToSetUserName={[]} />
            <button className='button1' onClick={ () => handleClickMpurse(state, dispatch, ['permit', 'addressPermitTo']) }>
              <img className='size2x2' src={iconMpurse} alt='mpurse' />
            </button>
            <button className='button1' onClick={ () => handleClickAddressHistory(state, dispatch, cookies, ['permit', 'addressPermitTo']) }>
              <img className='size2x2' src={iconList} alt='list' />
            </button>
          </div>
        </div>
      </div>
    </div>
  }
  else {
    addressPermitToField = null;
  }


  return (
    <div>
      {/* PC */}
      <div className="visibleLargeOrMore">
        <Header screen='permission' />
        <div className='flexRow justifyContentCenter '>
          {/* permit */}
          <div className='borderMonacotto backgroundColorTransparent padding1 margin1'>
            {/* title */}
            <div>
              {words.grantPermissionOfExhibit[state.language]}
            </div>
            {/* grant or revoke */}
            <div className='flexRow justifyContentCenter marginSide1'>
              <button className={'box3 focusEffect01 riseOut2 ' + (state.permit.action === 'grant' ? 'colorRed borderSelected' : 'borderNone')} tabindex='0'
                onClick={ () => {
                          dispatch({type: 'setStateMultiLayers', keys: ['permit', 'action'], value: 'grant'});
                }}>
                {words.grantPermission[state.language]}
              </button>
              <button className={'box3 focusEffect01 riseOut2 ' + (state.permit.action === 'revoke' ? 'colorRed borderSelected' : 'borderNone')} tabindex='0'
                onClick={ () => {
                          dispatch({type: 'setStateMultiLayers', keys: ['permit', 'action'], value: 'revoke'});
                }}>
                {words.revokePermission[state.language]}
              </button>
            </div>
            {/* individual or inclusive */}
            <div className='flexRow justifyContentCenter marginSide1'>
              <button className={'box3 focusEffect01 riseOut2 ' + (state.permit.mode === 'individual' ? 'colorRed borderSelected' : 'borderNone')} tabindex='0'
                onClick={ () => {
                          dispatch({type: 'setStateMultiLayers', keys: ['permit', 'mode'], value: 'individual'});
                }}>
                {words.individualPermission[state.language]}
              </button>
              <button className={'box3 focusEffect01 riseOut2 ' + (state.permit.mode === 'inclusive' ? 'colorRed borderSelected' : 'borderNone')} tabindex='0'
                onClick={ () => {
                          dispatch({type: 'setStateMultiLayers', keys: ['permit', 'mode'], value: 'inclusive'});
                }}>
                {words.inclusivePermission[state.language]}
              </button>
            </div>
            {/* owner address */}
            <div className='flexRow justifyContentFlexStart alignItemsCenter marginTop1 '>
              <TextLine3 fieldName='addressOwner' keys={['permit', 'addressOwner']} face={words.addressOwner[state.language]} tooltip={true} />
              <SelectSessionButton loginEnabled={true} setConfigure={true} />
              <button className='button1' onClick={ () => handleClickMpurse(state, dispatch, ['permit', 'addressOwner']) }>
                <img className='size2x2' src={iconMpurse} alt='mpurse' />
              </button>
              <button className='button1' onClick={ () => handleClickAddressHistory(state, dispatch, cookies, ['permit', 'addressOwner']) }>
                <img className='size2x2' src={iconList} alt='list' />
              </button>
            </div>
            {/* addressPermitTo */}
            { addressPermitToField }
            {
              state.permit.action === 'grant' ?
              <div>
                {/* addressPayRoyaltyTo */}
                <div className='flexRow justifyContentFlexStart alignItemsCenter marginTop1 '>
                  <TextLine3 fieldName='addressPayRoyaltyTo' keys={['permit', 'addressPayRoyaltyTo']}
                    face={words.addressPayRoyaltyTo[state.language]} tooltip={true}
                  />
                  <SelectSessionButton stateKeysToSetAddress={[['permit', 'addressPayRoyaltyTo']]} stateKeysToSetUserName={[]} />
                  <button className='button1' onClick={ () => handleClickMpurse(state, dispatch, ['permit', 'addressPayRoyaltyTo']) }>
                    <img className='size2x2' src={iconMpurse} alt='mpurse' />
                  </button>
                  <button className='button1' onClick={ () => handleClickAddressHistory(state, dispatch, cookies, ['permit', 'addressPayRoyaltyTo']) }>
                    <img className='size2x2' src={iconList} alt='list' />
                  </button>
                </div>
                {/* royaltyPercentage */}
                <TextLine3 fieldName='royaltyPercentage' keys={['permit', 'royaltyPercentage']}
                  face={words.royaltyPercentage[state.language]} type='setStateMultiLayersFloat' adjustType='round' adjustExp={royaltyPercentageDigit}
                />
              </div> :
              null
            }
            {/* commit button */}
            <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' tabindex='0'
              onClick={ async () => {
                const result = await handleClickPermit(state, dispatch, cookies, setCookie);

                if (result?.message === 'nfcRequired') {
                  const callback = (keyPairs) => {
                    handleClickPermit(state, dispatch, cookies, setCookie, keyPairs);
                    keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
                  };

                  handleClickNfc(state, dispatch, callback);
                }
                else if (result?.message === 'nfcNativeRequired') {
                  const { keyPairs } = await getSecretsFromNativeApp({ dispatch, pass: state.config.clientParameters.specialMessage, language: state.language, network: state.networkMona });

                  handleClickPermit(state, dispatch, cookies, setCookie, keyPairs);
                  keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
                }
                else if (result?.message === 'bcRequired') {
                  const callback = (keyPairs) => {
                    handleClickPermit(state, dispatch, cookies, setCookie, keyPairs);
                    keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
                  };

                  handleClickScanQr(state, dispatch, callback);
                }
              }}
            >
              <div>
                {words.signByOwnerAddressToRegister[state.language]}
              </div>
              <img className='size2x2' src={iconSign} alt='sign' />
            </button>
          </div>
          {/* request permission */}
          <div className='borderMonacotto backgroundColorTransparent padding1 margin1'>
            <div>
              {words.requestPermissionOfExhibit[state.language]}
            </div>
            <div className='flexRow justifyContentFlexStart alignItemsCenter marginTop1 '>
              <TextLine3 fieldName='requestPermissionAddressMain' keys={['requestPermission', 'addressMain']}
                face={words.addressMain[state.language]} tooltip={true} />
              <SelectSessionButton loginEnabled={true} setConfigure={true} />
              <button className='button1' onClick={ () => handleClickMpurse(state, dispatch, ['requestPermission', 'addressMain']) }>
                <img className='size2x2' src={iconMpurse} alt='mpurse' />
              </button>
              <button className='button1' onClick={ () => handleClickAddressHistory(state, dispatch, cookies, ['requestPermission', 'addressMain']) }>
                <img className='size2x2' src={iconList} alt='list' />
              </button>
            </div>
            <div className='flexRow justifyContentFlexStart alignItemsCenter marginTop1 '>
              <TextLine3 fieldName='requestPermissionAddressOwner' keys={['requestPermission', 'addressOwner']}
                face={words.addressOwner[state.language]} tooltip={true} />
            </div>
            {/* <TextLine3 fieldName='ownerName' keys={['permit', 'ownerName']} face='owner name' tooltip={true} /> */}
            <TextLine3 fieldName='requestPermissionRoyaltyPercentage' keys={['requestPermission', 'royaltyPercentage']}
              face={words.royaltyPercentage[state.language]} type='setStateMultiLayersFloat' adjustType='round' adjustExp={royaltyPercentageDigit}
            />
            <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' tabindex='0'
              onClick={ async () => {
                const result = await handleClickRequestPermission(state, dispatch, cookies, setCookie);

                if (result?.message === 'nfcRequired') {
                  const callback = (keyPairs) => {
                    handleClickRequestPermission(state, dispatch, cookies, setCookie, keyPairs);
                    keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
                  };

                  handleClickNfc(state, dispatch, callback);
                }
                else if (result?.message === 'nfcNativeRequired') {
                  const { keyPairs } = await getSecretsFromNativeApp({ dispatch, pass: state.config.clientParameters.specialMessage, language: state.language, network: state.networkMona });

                  handleClickRequestPermission(state, dispatch, cookies, setCookie, keyPairs);
                  keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
                }
                else if (result?.message === 'bcRequired') {
                  const callback = (keyPairs) => {
                    handleClickRequestPermission(state, dispatch, cookies, setCookie, keyPairs);
                    keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
                  };

                  handleClickScanQr(state, dispatch, callback);
                }
              }}
            >
              <div>
                {words.signByMainAddressToRegister[state.language]}
              </div>
              <img className='size2x2' src={iconSign} alt='sign' />
            </button>
          </div>
          {/* delegate */}
          <div className='borderMonacotto backgroundColorTransparent padding1 margin1'>
            {/* title */}
            <div>
              {words.signatureDelegation[state.language]}
            </div>
            {/* action */}
            <div className='flexRow justifyContentCenter marginSide1'>
              <button className={'box3 focusEffect01 riseOut2 ' + (state.delegate.action === 'request' ? 'colorRed borderSelected' : 'borderNone')} tabindex='0'
                onClick={ () => {
                          dispatch({type: 'setStateMultiLayers', keys: ['delegate', 'action'], value: 'request'});
                }}>
                {words.delegate[state.language]}
              </button>
              <button className={'box3 focusEffect01 riseOut2 ' + (state.delegate.action === 'revokeRequest' ? 'colorRed borderSelected' : 'borderNone')} tabindex='0'
                onClick={ () => {
                          dispatch({type: 'setStateMultiLayers', keys: ['delegate', 'action'], value: 'revokeRequest'});
                }}>
                {words.revokeDelegation[state.language]}
              </button>
            </div>
            <div className='flexRow justifyContentCenter marginSide1'>
              <button className={'box3 focusEffect01 riseOut2 ' + (state.delegate.action === 'accept' ? 'colorRed borderSelected' : 'borderNone')} tabindex='0'
                onClick={ () => {
                          dispatch({type: 'setStateMultiLayers', keys: ['delegate', 'action'], value: 'accept'});
                }}>
                {words.acceptDelegation[state.language]}
              </button>
              <button className={'box3 focusEffect01 riseOut2 ' + (state.delegate.action === 'revokeAcceptance' ? 'colorRed borderSelected' : 'borderNone')} tabindex='0'
                onClick={ () => {
                          dispatch({type: 'setStateMultiLayers', keys: ['delegate', 'action'], value: 'revokeAcceptance'});
                }}>
                {words.revokeAcceptance[state.language]}
              </button>
            </div>
            <div className='flexColumn alignItemsFlexStart' >
              {/* addressDelegateFrom */}
              <div className='flexRow justifyContentFlexStart alignItemsCenter marginTop1 '>
                <TextLine3 fieldName='delegateAddressMain' keys={['delegate', 'addressDelegateFrom']}
                  face={words.addressDelegateFrom[state.language]} tooltip={true}
                />
                <SelectSessionButton loginEnabled={true} setConfigure={true} />
                <button className='button1' onClick={ () => handleClickMpurse(state, dispatch, ['delegate', 'addressDelegateFrom']) }>
                  <img className='size2x2' src={iconMpurse} alt='mpurse' />
                </button>
                <button className='button1' onClick={ () => handleClickAddressHistory(state, dispatch, cookies, ['delegate', 'addressDelegateFrom']) }>
                  <img className='size2x2' src={iconList} alt='list' />
                </button>
              </div>
              {/* addressDelegateTo */}
              <div className='flexRow justifyContentFlexStart alignItemsCenter marginTop1 '>
                <TextLine3 fieldName='delegateAddressDelegateTo' keys={['delegate', 'addressDelegateTo']}
                  face={words.addressDelegateTo[state.language]} tooltip={true}
                />
                <SelectSessionButton stateKeysToSetAddress={[['delegate', 'addressDelegateTo']]} stateKeysToSetUserName={[]} />
                <button className='button1' onClick={ () => handleClickMpurse(state, dispatch, ['delegate', 'addressDelegateTo']) }>
                  <img className='size2x2' src={iconMpurse} alt='mpurse' />
                </button>
                <button className='button1' onClick={ () => handleClickAddressHistory(state, dispatch, cookies, ['delegate', 'addressDelegateTo']) }>
                  <img className='size2x2' src={iconList} alt='list' />
                </button>
              </div>
            </div>
            {/* register button */}
            <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' tabindex='0'
              onClick={ async () => {
                const result = await handleClickDelegate(state, dispatch, cookies, setCookie);

                if (result?.message === 'nfcRequired') {
                  const callback = (keyPairs) => {
                    handleClickDelegate(state, dispatch, cookies, setCookie, keyPairs);
                    keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
                  };

                  handleClickNfc(state, dispatch, callback);
                }
                else if (result?.message === 'nfcNativeRequired') {
                  const { keyPairs } = await getSecretsFromNativeApp({ dispatch, pass: state.config.clientParameters.specialMessage, language: state.language, network: state.networkMona });

                  handleClickDelegate(state, dispatch, cookies, setCookie, keyPairs);
                  keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
                }
                else if (result?.message === 'bcRequired') {
                  const callback = (keyPairs) => {
                    handleClickDelegate(state, dispatch, cookies, setCookie, keyPairs);
                    keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
                  };

                  handleClickScanQr(state, dispatch, callback);
                }
              }}
            >
              <div>
                { 
                  state.delegate.action === 'request' || state.delegate.action === 'revokeRequest' ?
                    words.signByDelegationSourceAddressToRegister[state.language]
                  : words.signByDelegatedAddressToRegister[state.language]
                }
              </div>
              <img className='size2x2' src={iconSign} alt='sign' />
            </button>
          </div>
        </div>
        {/* history */}
        <div className='flexRow justifyContentFlexStart alignItemsCenter marginTop1 '>
          {/* action */}
          <div className='flexRow justifyContentSpaceAround marginSide0p5 marginTop0p5'>
            <button className={'box3 focusEffect01 riseOut2 ' + (state.getPermissionHistory.action === 'permit' ? 'colorRed borderSelected' : 'borderNone')} tabindex='0'
              onClick={ () => {
                        dispatch({type: 'setStateMultiLayers', keys: ['getPermissionHistory', 'action'], value: 'permit'});
              }}>
              {words.permit[state.language]}
            </button>
            <button className={'box3 focusEffect01 riseOut2 ' + (state.getPermissionHistory.action === 'permitted' ? 'colorRed borderSelected' : 'borderNone')} tabindex='0'
              onClick={ () => {
                        dispatch({type: 'setStateMultiLayers', keys: ['getPermissionHistory', 'action'], value: 'permitted'});
              }}>
              {words.permitted[state.language]}
            </button>
            <button className={'box3 focusEffect01 riseOut2 ' + (state.getPermissionHistory.action === 'permittedInclusively' ? 'colorRed borderSelected' : 'borderNone')} tabindex='0'
              onClick={ () => {
                        dispatch({type: 'setStateMultiLayers', keys: ['getPermissionHistory', 'action'], value: 'permittedInclusively'});
              }}>
              {words.permittedInclusively[state.language]}
            </button>
            <button className={'box3 focusEffect01 riseOut2 ' + (state.getPermissionHistory.action === 'requestPermission' ? 'colorRed borderSelected' : 'borderNone')} tabindex='0'
              onClick={ () => {
                        dispatch({type: 'setStateMultiLayers', keys: ['getPermissionHistory', 'action'], value: 'requestPermission'});
              }}>
              {words.requestPermission[state.language]}
            </button>
            <button className={'box3 focusEffect01 riseOut2 ' + (state.getPermissionHistory.action === 'requestedPermission' ? 'colorRed borderSelected' : 'borderNone')} tabindex='0'
              onClick={ () => {
                        dispatch({type: 'setStateMultiLayers', keys: ['getPermissionHistory', 'action'], value: 'requestedPermission'});
              }}>
              {words.requestedPermission[state.language]}
            </button>
            <button className={'box3 focusEffect01 riseOut2 ' + (state.getPermissionHistory.action === 'delegate' ? 'colorRed borderSelected' : 'borderNone')} tabindex='0'
              onClick={ () => {
                        dispatch({type: 'setStateMultiLayers', keys: ['getPermissionHistory', 'action'], value: 'delegate'});
              }}>
              {words.delegate2[state.language]}
            </button>
            <button className={'box3 focusEffect01 riseOut2 ' + (state.getPermissionHistory.action === 'delegated' ? 'colorRed borderSelected' : 'borderNone')} tabindex='0'
              onClick={ () => {
                        dispatch({type: 'setStateMultiLayers', keys: ['getPermissionHistory', 'action'], value: 'delegated'});
              }}>
              {words.delegated[state.language]}
            </button>
          </div>
          {/* addressMain */}
          <TextLine3 fieldName='historyAddressMain' keys={['getPermissionHistory', 'addressMain']} face={words.addressMain[state.language]} tooltip={true}
            extraFunctionOnChange={ [
              {
                function: () => {
                  dispatch({ type: 'setStateMultiLayers', keys: ['getPermissionHistory', 'pagingIndex'],
                    value: { permit: 0, permitted: 0, permittedInclusively: 0, requestPermission: 0, requestedPermission: 0, delegate: 0, delegated: 0 }
                  });
                  dispatch({ type: 'setStateMultiLayers', keys: ['getPermissionHistory', 'lastEvaluatedKey'],
                    value: { permit: [], permitted: [], permittedInclusively: [], requestPermission: [], requestedPermission: [], delegate: [], delegated: [] }
                  });
                },
                arguments: [],
              }
            ]}
          />
          <SelectSessionButton
            stateKeysToSetAddress={[['getPermissionHistory', 'addressMain']]}
            stateKeysToSetUserName={[]}
            extraFunction={ () => {
              dispatch({ type: 'setStateMultiLayers', keys: ['getPermissionHistory', 'pagingIndex'],
                value: { permit: 0, permitted: 0, permittedInclusively: 0, requestPermission: 0, requestedPermission: 0, delegate: 0, delegated: 0 }
              });
              dispatch({ type: 'setStateMultiLayers', keys: ['getPermissionHistory', 'lastEvaluatedKey'],
                value: { permit: [], permitted: [], permittedInclusively: [], requestPermission: [], requestedPermission: [], delegate: [], delegated: [] }
              });
            }}
          />
          <button className='button1'
            onClick={ () => {
              handleClickMpurse(state, dispatch, ['getPermissionHistory', 'addressMain']);
              dispatch({ type: 'setStateMultiLayers', keys: ['getPermissionHistory', 'pagingIndex'],
                value: { permit: 0, permitted: 0, permittedInclusively: 0, requestPermission: 0, requestedPermission: 0, delegate: 0, delegated: 0 }
              });
              dispatch({ type: 'setStateMultiLayers', keys: ['getPermissionHistory', 'lastEvaluatedKey'],
                value: { permit: [], permitted: [], permittedInclusively: [], requestPermission: [], requestedPermission: [], delegate: [], delegated: [] }
              });
            }}
          >
            <img className='size2x2' src={iconMpurse} alt='mpurse' />
          </button>
          <button className='button1'
            onClick={ () => {
              handleClickAddressHistory(state, dispatch, cookies, ['getPermissionHistory', 'addressMain']);
              dispatch({ type: 'setStateMultiLayers', keys: ['getPermissionHistory', 'pagingIndex'],
                value: { permit: 0, permitted: 0, permittedInclusively: 0, requestPermission: 0, requestedPermission: 0, delegate: 0, delegated: 0 }
              });
              dispatch({ type: 'setStateMultiLayers', keys: ['getPermissionHistory', 'lastEvaluatedKey'],
                value: { permit: [], permitted: [], permittedInclusively: [], requestPermission: [], requestedPermission: [], delegate: [], delegated: [] }
              });
            }}
          >
            <img className='size2x2' src={iconList} alt='list' />
          </button>
          <button className='button1' tabindex='0' onClick={ () => historyFunction(0) } >
            <img className='size2x2' src={iconSearch} alt='search' />
          </button>
          { arrowLeft }
          { arrowRight }
        </div>
        { historyItems }
        {/* development */}
        <div>
          { process.env.REACT_APP_ENVIRONMENT === 'dev' ? <ForDevelopment /> : null }
        </div>
      </div>
      {/* SP */}
      <div className="visibleMiddleOrLess">
        <Header screen='permission' />
        <div className='flexColumn alignItemsCenter width98vw'>
          {/* permit */}
          <div className='flexColumn borderMonacotto backgroundColorTransparent padding1 marginTopBottom1'>
            {/* title */}
            <div>
              {words.grantPermissionOfExhibit[state.language]}
            </div>
            {/* grant or revoke */}
            <div className='flexRow justifyContentCenter marginSide1'>
              <button className={'box3 focusEffect01 riseOut2 ' + (state.permit.action === 'grant' ? 'colorRed borderSelected' : 'borderNone')} tabindex='0'
                onClick={ () => {
                          dispatch({type: 'setStateMultiLayers', keys: ['permit', 'action'], value: 'grant'});
                }}>
                {words.grantPermission[state.language]}
              </button>
              <button className={'box3 focusEffect01 riseOut2 ' + (state.permit.action === 'revoke' ? 'colorRed borderSelected' : 'borderNone')} tabindex='0'
                onClick={ () => {
                          dispatch({type: 'setStateMultiLayers', keys: ['permit', 'action'], value: 'revoke'});
                }}>
                {words.revokePermission[state.language]}
              </button>
            </div>
            {/* individual or inclusive */}
            <div className='flexRow justifyContentCenter marginSide1'>
              <button className={'box3 focusEffect01 riseOut2 ' + (state.permit.mode === 'individual' ? 'colorRed borderSelected' : 'borderNone')} tabindex='0'
                onClick={ () => {
                          dispatch({type: 'setStateMultiLayers', keys: ['permit', 'mode'], value: 'individual'});
                }}>
                {words.individualPermission[state.language]}
              </button>
              <button className={'box3 focusEffect01 riseOut2 ' + (state.permit.mode === 'inclusive' ? 'colorRed borderSelected' : 'borderNone')} tabindex='0'
                onClick={ () => {
                          dispatch({type: 'setStateMultiLayers', keys: ['permit', 'mode'], value: 'inclusive'});
                }}>
                {words.inclusivePermission[state.language]}
              </button>
            </div>
            {/* owner address */}
            <div className='flexColumn alignItemsFlexStart marginTopBottom0p5 '>
              <TextLine3 fieldName='addressOwner' keys={['permit', 'addressOwner']} face={words.addressOwner[state.language]} tooltip={true} />
              <div className='flexRow justifyContentFlexStart alignItemsCenter '>
                <SelectSessionButton loginEnabled={true} setConfigure={true} />
                <button className='button1' onClick={ () => handleClickMpurse(state, dispatch, ['permit', 'addressOwner']) }>
                  <img className='size2x2' src={iconMpurse} alt='mpurse' />
                </button>
                <button className='button1' onClick={ () => handleClickAddressHistory(state, dispatch, cookies, ['permit', 'addressOwner']) }>
                  <img className='size2x2' src={iconList} alt='list' />
                </button>
              </div>
            </div>
            {/* addressPermitTo */}
            { addressPermitToField }
            {
              state.permit.action === 'grant' ?
              <div>
                {/* addressPayRoyaltyTo */}
                <div className='flexColumn alignItemsFlexStart marginTopBottom0p5 '>
                  <TextLine3 fieldName='addressPayRoyaltyTo' keys={['permit', 'addressPayRoyaltyTo']}
                    face={words.addressPayRoyaltyTo[state.language]} tooltip={true}
                  />
                  <div className='flexRow justifyContentFlexStart alignItemsCenter '>
                    <SelectSessionButton stateKeysToSetAddress={[['permit', 'addressPayRoyaltyTo']]} stateKeysToSetUserName={[]} />
                    <button className='button1' onClick={ () => handleClickMpurse(state, dispatch, ['permit', 'addressPayRoyaltyTo']) }>
                      <img className='size2x2' src={iconMpurse} alt='mpurse' />
                    </button>
                    <button className='button1' onClick={ () => handleClickAddressHistory(state, dispatch, cookies, ['permit', 'addressPayRoyaltyTo']) }>
                      <img className='size2x2' src={iconList} alt='list' />
                    </button>
                  </div>
                </div>
                {/* royaltyPercentage */}
                <TextLine3 fieldName='royaltyPercentage' keys={['permit', 'royaltyPercentage']}
                  face={words.royaltyPercentage[state.language]} type='setStateMultiLayersFloat' adjustType='round' adjustExp={royaltyPercentageDigit}
                />
              </div> :
              null
            }
            {/* commit button */}
            <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1' tabindex='0'
              onClick={ async () => {
                const result = await handleClickPermit(state, dispatch, cookies, setCookie);

                if (result?.message === 'nfcRequired') {
                  const callback = (keyPairs) => {
                    handleClickPermit(state, dispatch, cookies, setCookie, keyPairs);
                    keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
                  };

                  handleClickNfc(state, dispatch, callback);
                }
                else if (result?.message === 'nfcNativeRequired') {
                  const { keyPairs } = await getSecretsFromNativeApp({ dispatch, pass: state.config.clientParameters.specialMessage, language: state.language, network: state.networkMona });

                  handleClickPermit(state, dispatch, cookies, setCookie, keyPairs);
                  keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
                }
                else if (result?.message === 'bcRequired') {
                  const callback = (keyPairs) => {
                    handleClickPermit(state, dispatch, cookies, setCookie, keyPairs);
                    keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
                  };

                  handleClickScanQr(state, dispatch, callback);
                }
              }}
            >
              <div>
                {words.signByOwnerAddressToRegister[state.language]}
              </div>
              <img className='size2x2' src={iconSign} alt='sign' />
            </button>
          </div>
          {/* request permission */}
          <div className='flexColumn borderMonacotto backgroundColorTransparent padding1 marginTopBottom1'>
            <div>
              {words.requestPermissionOfExhibit[state.language]}
            </div>
            <div className='flexColumn alignItemsFlexStart marginTopBottom0p5 '>
              <TextLine3 fieldName='requestPermissionAddressMain' keys={['requestPermission', 'addressMain']}
                face={words.addressMain[state.language]} tooltip={true} />
              <div className='flexRow justifyContentFlexStart alignItemsCenter '>
                <SelectSessionButton loginEnabled={true} setConfigure={true} />
                <button className='button1' onClick={ () => handleClickMpurse(state, dispatch, ['requestPermission', 'addressMain']) }>
                  <img className='size2x2' src={iconMpurse} alt='mpurse' />
                </button>
                <button className='button1' onClick={ () => handleClickAddressHistory(state, dispatch, cookies, ['requestPermission', 'addressMain']) }>
                  <img className='size2x2' src={iconList} alt='list' />
                </button>
              </div>
            </div>
            <TextLine3 fieldName='requestPermissionAddressOwner' keys={['requestPermission', 'addressOwner']}
              face={words.addressOwner[state.language]} tooltip={true} />
            <TextLine3 fieldName='requestPermissionRoyaltyPercentage' keys={['requestPermission', 'royaltyPercentage']}
              face={words.royaltyPercentage[state.language]} type='setStateMultiLayersFloat' adjustType='round' adjustExp={royaltyPercentageDigit}
            />
            <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1' tabindex='0'
              onClick={ async () => {
                const result = await handleClickRequestPermission(state, dispatch, cookies, setCookie);

                if (result?.message === 'nfcRequired') {
                  const callback = (keyPairs) => {
                    handleClickRequestPermission(state, dispatch, cookies, setCookie, keyPairs);
                    keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
                  };

                  handleClickNfc(state, dispatch, callback);
                }
                else if (result?.message === 'nfcNativeRequired') {
                  const { keyPairs } = await getSecretsFromNativeApp({ dispatch, pass: state.config.clientParameters.specialMessage, language: state.language, network: state.networkMona });

                  handleClickRequestPermission(state, dispatch, cookies, setCookie, keyPairs);
                  keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
                }
                else if (result?.message === 'bcRequired') {
                  const callback = (keyPairs) => {
                    handleClickRequestPermission(state, dispatch, cookies, setCookie, keyPairs);
                    keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
                  };

                  handleClickScanQr(state, dispatch, callback);
                }
              }}
            >
              <div>
                {words.signByMainAddressToRegister[state.language]}
              </div>
              <img className='size2x2' src={iconSign} alt='sign' />
            </button>
          </div>
          {/* delegate */}
          <div className='flexColumn borderMonacotto backgroundColorTransparent padding1 marginTopBottom1'>
            <div>
              {words.signatureDelegation[state.language]}
            </div>
            {/* action */}
            <div className='flexRow justifyContentCenter '>
              <button className={'box3 focusEffect01 riseOut2 ' + (state.delegate.action === 'request' ? 'colorRed borderSelected' : 'borderNone')} tabindex='0'
                onClick={ () => {
                          dispatch({type: 'setStateMultiLayers', keys: ['delegate', 'action'], value: 'request'});
                }}>
                {words.delegate[state.language]}
              </button>
              <button className={'box3 focusEffect01 riseOut2 ' + (state.delegate.action === 'revokeRequest' ? 'colorRed borderSelected' : 'borderNone')} tabindex='0'
                onClick={ () => {
                          dispatch({type: 'setStateMultiLayers', keys: ['delegate', 'action'], value: 'revokeRequest'});
                }}>
                {words.revokeDelegation[state.language]}
              </button>
            </div>
            <div className='flexRow justifyContentCenter '>
              <button className={'box3 focusEffect01 riseOut2 ' + (state.delegate.action === 'accept' ? 'colorRed borderSelected' : 'borderNone')} tabindex='0'
                onClick={ () => {
                          dispatch({type: 'setStateMultiLayers', keys: ['delegate', 'action'], value: 'accept'});
                }}>
                {words.acceptDelegation[state.language]}
              </button>
              <button className={'box3 focusEffect01 riseOut2 ' + (state.delegate.action === 'revokeAcceptance' ? 'colorRed borderSelected' : 'borderNone')} tabindex='0'
                onClick={ () => {
                          dispatch({type: 'setStateMultiLayers', keys: ['delegate', 'action'], value: 'revokeAcceptance'});
                }}>
                {words.revokeAcceptance[state.language]}
              </button>
            </div>
            <div className='flexColumn alignItemsFlexStart' >
              {/* addressDelegateFrom */}
              <div className='flexColumn alignItemsFlexStart marginTopBottom0p5 '>
                <TextLine3 fieldName='delegateAddressMain' keys={['delegate', 'addressDelegateFrom']}
                  face={words.addressDelegateFrom[state.language]} tooltip={true}
                />
                <div className='flexRow justifyContentFlexStart alignItemsCenter '>
                  <SelectSessionButton loginEnabled={true} setConfigure={true} />
                  <button className='button1' onClick={ () => handleClickMpurse(state, dispatch, ['delegate', 'addressDelegateFrom']) }>
                    <img className='size2x2' src={iconMpurse} alt='mpurse' />
                  </button>
                  <button className='button1' onClick={ () => handleClickAddressHistory(state, dispatch, cookies, ['delegate', 'addressDelegateFrom']) }>
                    <img className='size2x2' src={iconList} alt='list' />
                  </button>
                </div>
              </div>
              {/* addressDelegateTo */}
              <div className='flexColumn alignItemsFlexStart marginTopBottom0p5 '>
                <TextLine3 fieldName='delegateAddressDelegateTo' keys={['delegate', 'addressDelegateTo']}
                  face={words.addressDelegateTo[state.language]} tooltip={true}
                />
                <div className='flexRow justifyContentFlexStart alignItemsCenter '>
                  <SelectSessionButton stateKeysToSetAddress={[['delegate', 'addressDelegateTo']]} stateKeysToSetUserName={[]} />
                  <button className='button1' onClick={ () => handleClickMpurse(state, dispatch, ['delegate', 'addressDelegateTo']) }>
                    <img className='size2x2' src={iconMpurse} alt='mpurse' />
                  </button>
                  <button className='button1' onClick={ () => handleClickAddressHistory(state, dispatch, cookies, ['delegate', 'addressDelegateTo']) }>
                    <img className='size2x2' src={iconList} alt='list' />
                  </button>
                </div>
              </div>
            </div>
            {/* register button */}
            <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1' tabindex='0'
              onClick={ async () => {
                const result = await handleClickDelegate(state, dispatch, cookies, setCookie);

                if (result?.message === 'nfcRequired') {
                  const callback = (keyPairs) => {
                    handleClickDelegate(state, dispatch, cookies, setCookie, keyPairs);
                    keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
                  };

                  handleClickNfc(state, dispatch, callback);
                }
                else if (result?.message === 'nfcNativeRequired') {
                  const { keyPairs } = await getSecretsFromNativeApp({ dispatch, pass: state.config.clientParameters.specialMessage, language: state.language, network: state.networkMona });

                  handleClickDelegate(state, dispatch, cookies, setCookie, keyPairs);
                  keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
                }
                else if (result?.message === 'bcRequired') {
                  const callback = (keyPairs) => {
                    handleClickDelegate(state, dispatch, cookies, setCookie, keyPairs);
                    keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
                  };

                  handleClickScanQr(state, dispatch, callback);
                }
              }}
            >
              <div>
                {words.signByMainAddressToRegister[state.language]}
              </div>
              <img className='size2x2' src={iconSign} alt='sign' />
            </button>
          </div>
        </div>
        {/* history */}
        <div className='flexColumn alignItemsCenter marginTopBottom1 '>
          <div className='borderTopBottom marginTopBottom1'>
            {words.searchForPermissionToExhibitAndSignatureDelegation[state.language]}
          </div>
          {/* action */}
          <div className='flexColumn alignItemsCenter marginTopBottom0p5'>
            <div className='flexRow justifyContentCenter '>
              <button className={'box3 marginTopBottom0p5 focusEffect01 riseOut2 ' + (state.getPermissionHistory.action === 'permit' ? 'colorRed borderSelected' : 'borderNone')} tabindex='0'
                onClick={ () => {
                          dispatch({type: 'setStateMultiLayers', keys: ['getPermissionHistory', 'action'], value: 'permit'});
                }}>
                {words.permit[state.language]}
              </button>
              <button className={'box3 marginTopBottom0p5 focusEffect01 riseOut2 ' + (state.getPermissionHistory.action === 'permitted' ? 'colorRed borderSelected' : 'borderNone')} tabindex='0'
                onClick={ () => {
                          dispatch({type: 'setStateMultiLayers', keys: ['getPermissionHistory', 'action'], value: 'permitted'});
                }}>
                {words.permitted[state.language]}
              </button>
              <button className={'box3 marginTopBottom0p5 focusEffect01 riseOut2 ' + (state.getPermissionHistory.action === 'permittedInclusively' ? 'colorRed borderSelected' : 'borderNone')} tabindex='0'
                onClick={ () => {
                          dispatch({type: 'setStateMultiLayers', keys: ['getPermissionHistory', 'action'], value: 'permittedInclusively'});
                }}>
                {words.permittedInclusively[state.language]}
              </button>
            </div>
            <div className='flexRow justifyContentCenter '>
              <button className={'box3 marginTopBottom0p5 focusEffect01 riseOut2 ' + (state.getPermissionHistory.action === 'requestPermission' ? 'colorRed borderSelected' : 'borderNone')} tabindex='0'
                onClick={ () => {
                          dispatch({type: 'setStateMultiLayers', keys: ['getPermissionHistory', 'action'], value: 'requestPermission'});
                }}>
                {words.requestPermission[state.language]}
              </button>
              <button className={'box3 marginTopBottom0p5 focusEffect01 riseOut2 ' + (state.getPermissionHistory.action === 'requestedPermission' ? 'colorRed borderSelected' : 'borderNone')} tabindex='0'
                onClick={ () => {
                          dispatch({type: 'setStateMultiLayers', keys: ['getPermissionHistory', 'action'], value: 'requestedPermission'});
                }}>
                {words.requestedPermission[state.language]}
              </button>
            </div>
            <div className='flexRow justifyContentCenter '>
              <button className={'box3 marginTopBottom0p5 focusEffect01 riseOut2 ' + (state.getPermissionHistory.action === 'delegate' ? 'colorRed borderSelected' : 'borderNone')} tabindex='0'
                onClick={ () => {
                          dispatch({type: 'setStateMultiLayers', keys: ['getPermissionHistory', 'action'], value: 'delegate'});
                }}>
                {words.delegate2[state.language]}
              </button>
              <button className={'box3 marginTopBottom0p5 focusEffect01 riseOut2 ' + (state.getPermissionHistory.action === 'delegated' ? 'colorRed borderSelected' : 'borderNone')} tabindex='0'
                onClick={ () => {
                          dispatch({type: 'setStateMultiLayers', keys: ['getPermissionHistory', 'action'], value: 'delegated'});
                }}>
                {words.delegated[state.language]}
              </button>
            </div>
          </div>
          {/* addressMain */}
          <div className='flexColumn alignItemsFlexStart marginTopBottom0p5'>
            <TextLine3 fieldName='historyAddressMain' keys={['getPermissionHistory', 'addressMain']} face={words.addressMain[state.language]} tooltip={true}
              extraFunctionOnChange={ [
                {
                  function: () => {
                    dispatch({ type: 'setStateMultiLayers', keys: ['getPermissionHistory', 'pagingIndex'],
                      value: { permit: 0, permitted: 0, permittedInclusively: 0, requestPermission: 0, requestedPermission: 0, delegate: 0, delegated: 0 }
                    });
                    dispatch({ type: 'setStateMultiLayers', keys: ['getPermissionHistory', 'lastEvaluatedKey'],
                      value: { permit: [], permitted: [], permittedInclusively: [], requestPermission: [], requestedPermission: [], delegate: [], delegated: [] }
                    });
                  },
                  arguments: [],
                }
              ]}
            />
            <div className='flexRow alignItemsFlexStart '>
              <SelectSessionButton
                stateKeysToSetAddress={[['getPermissionHistory', 'addressMain']]}
                stateKeysToSetUserName={[]}
                extraFunction={ () => {
                  dispatch({ type: 'setStateMultiLayers', keys: ['getPermissionHistory', 'pagingIndex'],
                    value: { permit: 0, permitted: 0, permittedInclusively: 0, requestPermission: 0, requestedPermission: 0, delegate: 0, delegated: 0 }
                  });
                  dispatch({ type: 'setStateMultiLayers', keys: ['getPermissionHistory', 'lastEvaluatedKey'],
                    value: { permit: [], permitted: [], permittedInclusively: [], requestPermission: [], requestedPermission: [], delegate: [], delegated: [] }
                  });
                }}
              />
              <button className='button1'
                onClick={ () => {
                  handleClickMpurse(state, dispatch, ['getPermissionHistory', 'addressMain']);
                  dispatch({ type: 'setStateMultiLayers', keys: ['getPermissionHistory', 'pagingIndex'],
                    value: { permit: 0, permitted: 0, permittedInclusively: 0, requestPermission: 0, requestedPermission: 0, delegate: 0, delegated: 0 }
                  });
                  dispatch({ type: 'setStateMultiLayers', keys: ['getPermissionHistory', 'lastEvaluatedKey'],
                    value: { permit: [], permitted: [], permittedInclusively: [], requestPermission: [], requestedPermission: [], delegate: [], delegated: [] }
                  });
                }}
              >
                <img className='size2x2' src={iconMpurse} alt='mpurse' />
              </button>
              <button className='button1'
                onClick={ () => {
                  handleClickAddressHistory(state, dispatch, cookies, ['getPermissionHistory', 'addressMain']);
                  dispatch({ type: 'setStateMultiLayers', keys: ['getPermissionHistory', 'pagingIndex'],
                    value: { permit: 0, permitted: 0, permittedInclusively: 0, requestPermission: 0, requestedPermission: 0, delegate: 0, delegated: 0 }
                  });
                  dispatch({ type: 'setStateMultiLayers', keys: ['getPermissionHistory', 'lastEvaluatedKey'],
                    value: { permit: [], permitted: [], permittedInclusively: [], requestPermission: [], requestedPermission: [], delegate: [], delegated: [] }
                  });
                }}
              >
                <img className='size2x2' src={iconList} alt='list' />
              </button>
              <button className='button1' tabindex='0' onClick={ () => historyFunction(0) } >
                <img className='size2x2' src={iconSearch} alt='search' />
              </button>
            </div>
          </div>
          <div className='flexRow marginTopBottom0p5'>
            <div className='marginSide1'>
              { arrowLeft }
            </div>
            <div className='marginSide1'>
              { arrowRight }
            </div>
          </div>
        </div>
        { historyItems }
      </div>
    </div>
  );
}

// PERMIT RECORD TITLE
function PermitRecordTitle() {
  const state = useGlobalStateSelector( ({ state }) => state );

  return (
    <div>
      {/* PC */}
      <div className="visibleLargeOrMore">
        <div className='boxHistory flexRow justifyContentSpaceBetween alignItemsCenter textCenter'  >
          <div className='marginSide1 widthMin7' >
            { words.userNamePermitTo[state.language] }
          </div>
          <div className='marginSide1 widthMin25' >
            { words.addressPermitTo[state.language] }
          </div>
          <div className='marginSide1 widthMin7' >
            { words.royaltyPercentage[state.language] }
          </div>
          <div className='marginSide1 widthMin25' >
            { words.addressPayRoyaltyTo[state.language] }
          </div>
        </div>
      </div>
      {/* SP */}
    </div>
  );
}

// PERMIT RECORD
function PermitRecord(props) {
  const state = useGlobalStateSelector( ({ state }) => state );
  const record = props.record;
  let addressPermitTo;
  let userNamePermitTo;

  // const popup = { type: 'exhibitRecordDetail', body: props.record };

  // addressPermitTo
  if (record.mode === 'inclusive') {
    addressPermitTo = null;
    userNamePermitTo = words.inclusivePermission[state.language];
  }
  else { // individual or undefined
    addressPermitTo = record.addressPermitTo;
    userNamePermitTo = state.usersGeneralIndex[record.addressPermitTo] !== undefined ? state.usersGeneralIndex[record.addressPermitTo].userName : null;
  }


  return (
    <div>
      {/* PC */}
      <div className="visibleLargeOrMore">
        <div className='boxHistory flexRow justifyContentSpaceBetween alignItemsCenter textCenter'  >
          <div className='marginSide1 widthMin7' >
            { userNamePermitTo }
          </div>
          <div className='marginSide1 widthMin25' >
            { addressPermitTo }
          </div>
          <div className='marginSide1 widthMin7' >
            { props.record.royaltyPercentage + '%' }
          </div>
          <div className='marginSide1 widthMin25' >
            { props.record.addressPayRoyaltyTo }
          </div>
        </div>
      </div>
      {/* SP */}
      <div className="visibleMiddleOrLess">
        <div className='boxMonacotto1SmallScreen flexColumn alignItemsFlexStart '  >
          <div className='flexRow justifyContentSpaceBetween alignItemsCenter width98PC'>
            <div className='' >
              { words.userNamePermitTo[state.language] }
            </div>
            <div className='' >
              { userNamePermitTo }
            </div>
          </div>
          <div className='flexColumn alignItemsFlexStart width98PC'>
            <div className='' >
              { words.addressPermitTo[state.language] }
            </div>
            <div className='widthMax textRight' >
              { addressPermitTo }
            </div>
          </div>
          <div className='flexRow justifyContentSpaceBetween alignItemsCenter width98PC'>
            <div className='' >
              { words.royaltyPercentage[state.language] }
            </div>
            <div className='' >
              { props.record.royaltyPercentage + '%' }
            </div>
          </div>
          <div className='flexColumn alignItemsFlexStart width98PC'>
            <div className='' >
              { words.addressPayRoyaltyTo[state.language] }
            </div>
            <div className='widthMax textRight' >
              { props.record.addressPayRoyaltyTo }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// PERMITTED RECORD TITLE
function PermittedRecordTitle() {
  const state = useGlobalStateSelector( ({ state }) => state );

  return (
    <div>
      {/* PC */}
      <div className="visibleLargeOrMore">
        <div className='boxHistory flexRow justifyContentSpaceBetween alignItemsCenter textCenter'  >
          <div className='marginSide1 widthMin7' >
            { words.ownerName[state.language] }
          </div>
          <div className='marginSide1 widthMin25' >
            { words.addressOwner[state.language] }
          </div>
          <div className='marginSide1 widthMin7' >
            { words.royaltyPercentage[state.language] }
          </div>
          {/*
            <div className='marginSide1 widthMin7' >
              { words.permissionMode[state.language] }
            </div>
          */}
          <div className='marginSide1 widthMin25' >
            { words.addressPayRoyaltyTo[state.language] }
          </div>
        </div>
      </div>
      {/* SP */}
    </div>
  );
}

// PERMITTED RECORD
function PermittedRecord(props) {
  const state = useGlobalStateSelector( ({ state }) => state );
  // const record = props.record;
  // let modeWord;

  // const popup = { type: 'exhibitRecordDetail', body: props.record };

  // // modeWord
  // if (record.mode === 'individual') {
  //   modeWord = words.individualPermission[state.language];
  // }
  // else { // inclusive
  //   modeWord = words.inclusivePermission[state.language];
  // }


  return (
    <div>
      {/* PC */}
      <div className="visibleLargeOrMore">
        <div className='boxHistory flexRow justifyContentSpaceBetween alignItemsCenter textCenter'  >
          <div className='marginSide1 widthMin7' >
            { state.usersGeneralIndex[props.record.addressOwner] !== undefined ? state.usersGeneralIndex[props.record.addressOwner].userName : null }
          </div>
          <div className='marginSide1 widthMin25' >
            { props.record.addressOwner }
          </div>
          <div className='marginSide1 widthMin7' >
            { props.record.royaltyPercentage + '%' }
          </div>
          {/*
            <div className='marginSide1 widthMin7' >
              { modeWord }
            </div>
          */}
          <div className='marginSide1 widthMin25' >
            { props.record.addressPayRoyaltyTo }
          </div>
        </div>
      </div>
      {/* SP */}
      <div className="visibleMiddleOrLess">
        <div className='boxMonacotto1SmallScreen flexColumn alignItemsFlexStart '  >
          <div className='flexRow justifyContentSpaceBetween alignItemsCenter width98PC'>
            <div className='' >
              { words.ownerName[state.language] }
            </div>
            <div className='' >
              { state.usersGeneralIndex[props.record.addressOwner] !== undefined ? state.usersGeneralIndex[props.record.addressOwner].userName : null }
            </div>
          </div>
          <div className='flexColumn alignItemsFlexStart width98PC'>
            <div className='' >
              { words.addressOwner[state.language] }
            </div>
            <div className='widthMax textRight' >
              { props.record.addressOwner }
            </div>
          </div>
          <div className='flexRow justifyContentSpaceBetween alignItemsCenter width98PC'>
            <div className='' >
              { words.royaltyPercentage[state.language] }
            </div>
            <div className='' >
              { props.record.royaltyPercentage + '%' }
            </div>
          </div>
          {/*
            <div className='flexColumn alignItemsFlexStart width98PC'>
              <div className='' >
                { words.permissionMode[state.language] }
              </div>
              <div className='widthMax textRight' >
                { modeWord }
              </div>
            </div>
          */}
          <div className='flexColumn alignItemsFlexStart width98PC'>
            <div className='' >
              { words.addressPayRoyaltyTo[state.language] }
            </div>
            <div className='widthMax textRight' >
              { props.record.addressPayRoyaltyTo }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// REQUEST PERMISSION RECORD TITLE
function RequestPermissionRecordTitle() {
  const state = useGlobalStateSelector( ({ state }) => state );

  return (
    <div>
      {/* PC */}
      <div className="visibleLargeOrMore">
        <div className='boxHistory flexRow justifyContentSpaceBetween alignItemsCenter textCenter'  >
          <div className='marginSide1 widthMin7' >
            { words.ownerName[state.language] }
          </div>
          <div className='marginSide1 widthMin25' >
            { words.addressOwner[state.language] }
          </div>
          <div className='marginSide1 widthMin7' >
            { words.royaltyPercentage[state.language] }
          </div>
        </div>
      </div>
      {/* SP */}
    </div>
  );
}

// REQUEST PERMISSION RECORD
function RequestPermissionRecord(props) {
  const state = useGlobalStateSelector( ({ state }) => state );

  // const popup = { type: 'exhibitRecordDetail', body: props.record };

  return (
    <div>
      {/* PC */}
      <div className="visibleLargeOrMore">
        <div className='boxHistory flexRow justifyContentSpaceBetween alignItemsCenter textCenter'  >
          <div className='marginSide1 widthMin7' >
            { state.usersGeneralIndex[props.record.addressOwner] !== undefined ? state.usersGeneralIndex[props.record.addressOwner].userName : null }
          </div>
          <div className='marginSide1 widthMin25' >
            { props.record.addressOwner }
          </div>
          <div className='marginSide1 widthMin7' >
            { props.record.royaltyPercentage + '%' }
          </div>
        </div>
      </div>
      {/* SP */}
      <div className="visibleMiddleOrLess">
        <div className='boxMonacotto1SmallScreen flexColumn alignItemsFlexStart '  >
          <div className='flexRow justifyContentSpaceBetween alignItemsCenter width98PC'>
            <div className='' >
              { words.ownerName[state.language] }
            </div>
            <div className='' >
              { state.usersGeneralIndex[props.record.addressOwner] !== undefined ? state.usersGeneralIndex[props.record.addressOwner].userName : null }
            </div>
          </div>
          <div className='flexColumn alignItemsFlexStart width98PC'>
            <div className='' >
              { words.addressOwner[state.language] }
            </div>
            <div className='widthMax textRight' >
              { props.record.addressOwner }
            </div>
          </div>
          <div className='flexRow justifyContentSpaceBetween alignItemsCenter width98PC'>
            <div className='' >
              { words.royaltyPercentage[state.language] }
            </div>
            <div className='' >
              { props.record.royaltyPercentage + '%' }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// REQUESTED PERMISSION RECORD TITLE
function RequestedPermissionRecordTitle() {
  const state = useGlobalStateSelector( ({ state }) => state );

  return (
    <div>
      {/* PC */}
      <div className="visibleLargeOrMore">
        <div className='boxHistory flexRow justifyContentSpaceBetween alignItemsCenter textCenter'  >
          <div className='marginSide1 widthMin7' >
            { words.userNamePermitTo[state.language] }
          </div>
          <div className='marginSide1 widthMin25' >
            { words.addressPermitTo[state.language] }
          </div>
          <div className='marginSide1 widthMin7' >
            { words.royaltyPercentage[state.language] }
          </div>
          <button className='dummyPadButton1 backgroundColorMonacottoAlmostWhite' disabled={true} />
        </div>
      </div>
      {/* SP */}
    </div>
  );
}

// REQUESTED PERMISSION RECORD
function RequestedPermissionRecord(props) {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );

  // const popup = { type: 'exhibitRecordDetail', body: props.record };

  return (
    <div>
      {/* PC */}
      <div className="visibleLargeOrMore">
        <div className='boxHistory flexRow justifyContentSpaceBetween alignItemsCenter textCenter'  >
          <div className='marginSide1 widthMin7' >
            { state.usersGeneralIndex[props.record.addressMain] !== undefined ? state.usersGeneralIndex[props.record.addressMain].userName : null }
          </div>
          <div className='marginSide1 widthMin25' >
            { props.record.addressMain }
          </div>
          <div className='marginSide1 widthMin7' >
            { props.record.royaltyPercentage + '%' }
          </div>
          <button className='button1' disabled={props.disabled ? true : false}
            onClick={ () => {
              const royaltyPercentage = {
                face: props.record.royaltyPercentage,
                value: props.record.royaltyPercentage,
              }

              dispatch({ type: 'setStateMultiLayers', keys: ['permit', 'addressOwner'], value: props.record.addressOwner });
              dispatch({ type: 'setStateMultiLayers', keys: ['permit', 'addressPermitTo'], value: props.record.addressMain });
              dispatch({ type: 'setStateMultiLayers', keys: ['permit', 'royaltyPercentage'], value: royaltyPercentage });
            }}
          >
            <img className='size2x2' src={iconHandShake} alt='handshake' />
          </button>
        </div>
      </div>
      {/* SP */}
      <div className="visibleMiddleOrLess">
        <div className='boxMonacotto1SmallScreen flexColumn alignItemsFlexStart '  >
          <div className='flexRow justifyContentSpaceBetween alignItemsCenter width98PC'>
            <div className='' >
              { words.userNamePermitTo[state.language] }
            </div>
            <div className='flexRow alignItemsCenter' >
              <div className='' >
                { state.usersGeneralIndex[props.record.addressMain] !== undefined ? state.usersGeneralIndex[props.record.addressMain].userName : null }
              </div>
              <button className='button1' disabled={props.disabled ? true : false}
                onClick={ () => {
                  const royaltyPercentage = {
                    face: props.record.royaltyPercentage,
                    value: props.record.royaltyPercentage,
                  }

                  dispatch({ type: 'setStateMultiLayers', keys: ['permit', 'addressOwner'], value: props.record.addressOwner });
                  dispatch({ type: 'setStateMultiLayers', keys: ['permit', 'addressPermitTo'], value: props.record.addressMain });
                  dispatch({ type: 'setStateMultiLayers', keys: ['permit', 'royaltyPercentage'], value: royaltyPercentage });
                }}
              >
                <img className='size2x2' src={iconHandShake} alt='handshake' />
              </button>
            </div>
          </div>
          <div className='flexColumn alignItemsFlexStart width98PC'>
            <div className='' >
              { words.addressPermitTo[state.language] }
            </div>
            <div className='widthMax textRight' >
              { props.record.addressMain }
            </div>
          </div>
          <div className='flexRow justifyContentSpaceBetween alignItemsCenter width98PC'>
            <div className='' >
              { words.royaltyPercentage[state.language] }
            </div>
            <div className='' >
              { props.record.royaltyPercentage + '%' }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// DELEGATE RECORD TITLE
function DelegateRecordTitle() {
  const state = useGlobalStateSelector( ({ state }) => state );

  return (
    <div>
      {/* PC */}
      <div className="visibleLargeOrMore">
        <div className='boxHistory flexRow justifyContentSpaceBetween alignItemsCenter textCenter'  >
          <div className='marginSide1 widthMin7' >
            { words.userNameDelegateTo[state.language] }
          </div>
          <div className='marginSide1 widthMin25' >
            { words.addressDelegateTo[state.language] }
          </div>
          <div className='marginSide1 widthMin7' >
            { words.statusRequest[state.language] }
          </div>
          <div className='marginSide1 widthMin7' >
            { words.statusAccept[state.language] }
          </div>
          <button className='dummyPadButton1 backgroundColorMonacottoAlmostWhite' disabled={true} />
        </div>
      </div>
      {/* SP */}
    </div>
  );
}

// DELEGATE RECORD
function DelegateRecord(props) {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );

  // const popup = { type: 'exhibitRecordDetail', body: props.record };

  let wordStatusRequest;
  let wordStatusAccept;

  if (props.record.statusRequest !== undefined) {
    wordStatusRequest = words[props.record.statusRequest][state.language]; 
  }
  else {
    wordStatusRequest = words.invalid[state.language];
  }

  if (props.record.statusAccept !== undefined) {
    wordStatusAccept = words[props.record.statusAccept][state.language]; 
  }
  else {
    wordStatusAccept = words.invalid[state.language];
  }

  return (
    <div>
      {/* PC */}
      <div className="visibleLargeOrMore">
        <div className='boxHistory flexRow justifyContentSpaceBetween alignItemsCenter textCenter'  >
          <div className='marginSide1 widthMin7' >
            { state.usersGeneralIndex[props.record.addressDelegateTo] !== undefined ? state.usersGeneralIndex[props.record.addressDelegateTo].userName : null }
          </div>
          <div className='marginSide1 widthMin25' >
            { props.record.addressDelegateTo }
          </div>
          <div className='marginSide1 widthMin7' >
            { wordStatusRequest }
          </div>
          <div className='marginSide1 widthMin7' >
            { wordStatusAccept }
          </div>
          <button className='button1' disabled={props.disabled ? true : false}
            onClick={ () => {
              dispatch({ type: 'setStateMultiLayers', keys: ['delegate', 'addressDelegateFrom'], value: props.record.addressDelegateFrom });
              dispatch({ type: 'setStateMultiLayers', keys: ['delegate', 'addressDelegateTo'], value: props.record.addressDelegateTo });
              dispatch({ type: 'setStateMultiLayers', keys: ['delegate', 'action'], value: props.record.statusRequest !== 'valid' ? 'request' : 'revokeRequest' });
            }}
          >
            <img className='size2x2' src={iconHandShake} alt='handshake' />
          </button>
        </div>
      </div>
      {/* SP */}
      <div className="visibleMiddleOrLess">
        <div className='boxMonacotto1SmallScreen flexColumn alignItemsFlexStart '  >
          <div className='flexRow justifyContentSpaceBetween alignItemsCenter width98PC'>
            <div className='' >
              { words.userNameDelegateTo[state.language] }
            </div>
            <div className='flexRow alignItemsCenter' >
              <div className='' >
                { state.usersGeneralIndex[props.record.addressDelegateTo] !== undefined ? state.usersGeneralIndex[props.record.addressDelegateTo].userName : null }
              </div>
              <button className='button1' disabled={props.disabled ? true : false}
                onClick={ () => {
                  dispatch({ type: 'setStateMultiLayers', keys: ['delegate', 'addressDelegateFrom'], value: props.record.addressDelegateFrom });
                  dispatch({ type: 'setStateMultiLayers', keys: ['delegate', 'addressDelegateTo'], value: props.record.addressDelegateTo });
                  dispatch({ type: 'setStateMultiLayers', keys: ['delegate', 'action'], value: props.record.statusRequest !== 'valid' ? 'request' : 'revokeRequest' });
                }}
              >
                <img className='size2x2' src={iconHandShake} alt='handshake' />
              </button>
            </div>
          </div>
          <div className='flexColumn alignItemsFlexStart width98PC'>
            <div className='' >
              { words.addressDelegateTo[state.language] }
            </div>
            <div className='widthMax textRight' >
              { props.record.addressDelegateTo }
            </div>
          </div>
          <div className='flexRow justifyContentSpaceBetween alignItemsCenter width98PC'>
            <div className='' >
              { words.statusRequest[state.language] }
            </div>
            <div className='' >
              { wordStatusRequest }
            </div>
          </div>
          <div className='flexRow justifyContentSpaceBetween alignItemsCenter width98PC'>
            <div className='' >
              { words.statusAccept[state.language] }
            </div>
            <div className='' >
              { wordStatusAccept }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// DELEGATED RECORD TITLE
function DelegatedRecordTitle() {
  const state = useGlobalStateSelector( ({ state }) => state );

  return (
    <div>
      {/* PC */}
      <div className="visibleLargeOrMore">
        <div className='boxHistory flexRow justifyContentSpaceBetween alignItemsCenter textCenter'  >
          <div className='marginSide1 widthMin7' >
            { words.userNameDelegateFrom[state.language] }
          </div>
          <div className='marginSide1 widthMin25' >
            { words.addressDelegateFrom[state.language] }
          </div>
          <div className='marginSide1 widthMin7' >
            { words.statusRequest[state.language] }
          </div>
          <div className='marginSide1 widthMin7' >
            { words.statusAccept[state.language] }
          </div>
          <button className='dummyPadButton1 backgroundColorMonacottoAlmostWhite' disabled={true} />
        </div>
      </div>
      {/* SP */}
    </div>
  );
}

// DELEGATED RECORD
function DelegatedRecord(props) {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );

  // const popup = { type: 'exhibitRecordDetail', body: props.record };

  let wordStatusRequest;
  let wordStatusAccept;

  if (props.record.statusRequest !== undefined) {
    wordStatusRequest = words[props.record.statusRequest][state.language]; 
  }
  else {
    wordStatusRequest = words.invalid[state.language];
  }

  if (props.record.statusAccept !== undefined) {
    wordStatusAccept = words[props.record.statusAccept][state.language]; 
  }
  else {
    wordStatusAccept = words.invalid[state.language];
  }

  return (
    <div>
      {/* PC */}
      <div className="visibleLargeOrMore">
        <div className='boxHistory flexRow justifyContentSpaceBetween alignItemsCenter textCenter'  >
          <div className='marginSide1 widthMin7' >
            { state.usersGeneralIndex[props.record.addressDelegateFrom] !== undefined ? state.usersGeneralIndex[props.record.addressDelegateFrom].userName : null }
          </div>
          <div className='marginSide1 widthMin25' >
            { props.record.addressDelegateFrom }
          </div>
          <div className='marginSide1 widthMin7' >
            { wordStatusRequest }
          </div>
          <div className='marginSide1 widthMin7' >
            { wordStatusAccept }
          </div>
          <button className='button1' disabled={props.disabled ? true : false}
            onClick={ () => {
              dispatch({ type: 'setStateMultiLayers', keys: ['delegate', 'addressDelegateFrom'], value: props.record.addressDelegateFrom });
              dispatch({ type: 'setStateMultiLayers', keys: ['delegate', 'addressDelegateTo'], value: props.record.addressDelegateTo });
              dispatch({ type: 'setStateMultiLayers', keys: ['delegate', 'action'], value: props.record.statusAccept !== 'valid' ? 'accept' : 'revokeAcceptance' });
            }}
          >
            <img className='size2x2' src={iconHandShake} alt='handshake' />
          </button>
        </div>
      </div>
      {/* SP */}
      <div className="visibleMiddleOrLess">
        <div className='boxMonacotto1SmallScreen flexColumn alignItemsFlexStart '  >
          <div className='flexRow justifyContentSpaceBetween alignItemsCenter width98PC'>
            <div className='' >
              { words.userNameDelegateFrom[state.language] }
            </div>
            <div className='flexRow alignItemsCenter' >
              <div className='' >
                { state.usersGeneralIndex[props.record.addressDelegateFrom] !== undefined ? state.usersGeneralIndex[props.record.addressDelegateFrom].userName : null }
              </div>
              <button className='button1' disabled={props.disabled ? true : false}
                onClick={ () => {
                  dispatch({ type: 'setStateMultiLayers', keys: ['delegate', 'addressDelegateFrom'], value: props.record.addressDelegateFrom });
                  dispatch({ type: 'setStateMultiLayers', keys: ['delegate', 'addressDelegateTo'], value: props.record.addressDelegateTo });
                  dispatch({ type: 'setStateMultiLayers', keys: ['delegate', 'action'], value: props.record.statusAccept !== 'valid' ? 'accept' : 'revokeAcceptance' });
                }}
              >
                <img className='size2x2' src={iconHandShake} alt='handshake' />
              </button>
            </div>
          </div>
          <div className='flexColumn alignItemsFlexStart width98PC'>
            <div className='' >
              { words.addressDelegateFrom[state.language] }
            </div>
            <div className='widthMax textRight' >
              { props.record.addressDelegateFrom }
            </div>
          </div>
          <div className='flexRow justifyContentSpaceBetween alignItemsCenter width98PC'>
            <div className='' >
              { words.statusRequest[state.language] }
            </div>
            <div className='' >
              { wordStatusRequest }
            </div>
          </div>
          <div className='flexRow justifyContentSpaceBetween alignItemsCenter width98PC'>
            <div className='' >
              { words.statusAccept[state.language] }
            </div>
            <div className='' >
              { wordStatusAccept }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export {
  Permission,
}
